import React from 'react';
import ImageGallery from '../components/ImageGallery';
import { imageData } from '../data/images';

const Images: React.FC = () => {
  return (
    <section className="content-section">
      <div className="container">
        <h1 className="section-title">Images</h1>
        <p style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)', fontSize: '1.2rem' }}>
          Check out photos from our performances.
        </p>
        
        <ImageGallery images={imageData} />
      </div>
    </section>
  );
};

export default Images;
